(function () {
  function nav(open) {
    var drawer = document.querySelector('[data-an-mobile-nav]');
    var toggle = document.querySelector('[data-an-nav-toggle]');
    if (!drawer || !toggle) return;
    drawer.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('an-nav-open', open);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-an-nav-toggle]')) { nav(true); return; }
    if (event.target.closest('[data-an-nav-close]')) { nav(false); return; }

    var filter = event.target.closest('[data-anila-filter]');
    if (filter) {
      var value = filter.getAttribute('data-anila-filter');
      document.querySelectorAll('[data-anila-filter]').forEach(function (button) {
        var active = button === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      document.querySelectorAll('[data-product-card]').forEach(function (card) {
        card.hidden = value !== 'all' && card.getAttribute('data-category') !== value;
      });
    }

    var thumb = event.target.closest('[data-an-product-thumb]');
    if (thumb) {
      var root = thumb.closest('[data-an-product]');
      var main = root && root.querySelector('.an-product__main-image, [data-an-product-main]');
      if (!main) return;
      main.src = thumb.getAttribute('data-src');
      main.alt = thumb.getAttribute('data-alt') || '';
      root.querySelectorAll('[data-an-product-thumb]').forEach(function (button) { button.classList.toggle('is-active', button === thumb); });
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-an-variant-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var root = select.closest('[data-an-product]');
    var price = root && root.querySelector('[data-an-product-price]');
    var add = root && root.querySelector('[data-an-product-add]');
    if (price) price.textContent = option.getAttribute('data-price') || price.textContent;
    if (add) { add.disabled = option.disabled; add.textContent = option.disabled ? 'Agotado' : 'Agregar al carrito'; }
  });

  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') nav(false); });
})();
